/**
 * @desc 时效设置-默认时效详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductTimelinessSettingResponseDto>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessSetting/defaultDetails`, {
      method: "GET",

      ...options,
    }),
  );
}
